// /app/frontend/src/lib/userFetch.js
// Helper para llamadas a endpoints de USUARIO autenticado.
// Adjunta automáticamente el header Authorization: Bearer <Firebase ID Token>.
// Para uso en endpoints como:
//   - POST /api/spin
//   - POST /api/user/{uid}/xp/claim
//   - POST /api/rewards/{reward_id}/claim
//   - POST /api/payments/mercadopago/preference
import { auth } from "./firebase";

export class UserAuthError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
  }
}

/**
 * Devuelve el Firebase ID Token del usuario actual.
 * Lanza UserAuthError("NO_SESSION") si no hay sesión activa.
 */
export async function getUserIdToken() {
  const u = auth?.currentUser;
  if (!u) {
    throw new UserAuthError(
      "Debes iniciar sesión para continuar",
      "NO_SESSION"
    );
  }
  // forceRefresh=false; Firebase refresca solo si está cerca de expirar
  return u.getIdToken();
}

/**
 * fetch() autenticado con Bearer token Firebase.
 * Mismo contrato que fetch nativo.
 */
export async function userFetch(url, options = {}) {
  const token = await getUserIdToken();
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  if (options.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  return fetch(url, { ...options, headers });
}
